module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel01_1280_1280_en-f3ee23cc37ea48b1605accb178bcd363.jpg";